import { ServiceSessionWrapupEvent } from '@modules/ServiceModule/workspace/types/ServiceEvents';
import { InboxContext } from '../types';
import { setExternalCallWrapupTime } from '../callHandlers/externalCalls';

function handleSessionWrapupStarted(
  context: InboxContext,
  event: ServiceSessionWrapupEvent,
) {
  setExternalCallWrapupTime(
    context,
    event.sessionSid,
    event.userId,
    event.timestamp,
    event.wrapupAllowedMs,
  );
}

export default handleSessionWrapupStarted;
